var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../styled';
import Text from '../text';
const TextWrapper = styled.div `
  display: flex;
  align-items: center;
  word-break: break-word;
`;
const HiddenInput = styled.input `
  display: none;
`;
const RadioButton = styled.div `
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  border: 0.0625rem solid ${({ theme }) => theme.colors.INK_300};
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  display: inline-flex;
  position: relative;
  margin-top: 0.125rem;
  &:after {
    content: '';
    display: none;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.25rem;
    background-color: ${({ theme }) => theme.colors.PRIMARY_600};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:hover {
    border-color: ${({ theme }) => theme.colors.PRIMARY_600};
  }
`;
const RadioButtonWrapper = styled.label `
  display: inline-flex;
  align-items: flex-start;
  cursor: pointer;
  outline: none;
  span {
    display: inline-flex;
    padding-left: 0.5rem;
    max-width: 7.5rem;
    color: ${({ theme }) => theme.colors.INK_800};
  }

  > input:checked + ${RadioButton}:after {
    display: inline-block;
  }

  ${props => props.disabled &&
    css `
      cursor: not-allowed;
      color: ${({ theme }) => theme.colors.INK_400};
      ${RadioButton} {
        border: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
        background-color: ${({ theme }) => theme.colors.SNOW_400};
        :after {
          background-color: ${({ theme }) => theme.colors.INK_400};
        }
      }
      span {
        color: ${({ theme }) => theme.colors.INK_500};
      }
    `};

  ${props => !props.disabled &&
    css `
      :focus > ${RadioButton} {
        border: 0.0625rem solid ${({ theme }) => theme.colors.PRIMARY_600};
      }
      > input:checked + ${RadioButton} {
        border: 0.0625rem solid ${({ theme }) => theme.colors.PRIMARY_600};
      }
    `};
`;
const RadioButtonComponent = (_a) => {
    var { label, disabled, value, innerRef, lang = 'en' } = _a, restProps = __rest(_a, ["label", "disabled", "value", "innerRef", "lang"]);
    const textLabel = label && (React.createElement(TextWrapper, null,
        React.createElement(Text, { fontType: "Body", lang: lang, color: "INK_600" }, label)));
    return (React.createElement(RadioButtonWrapper, { disabled: disabled, tabIndex: disabled ? -1 : 0 },
        React.createElement(HiddenInput, Object.assign({ type: "radio", disabled: disabled, value: value, ref: innerRef }, restProps)),
        React.createElement(RadioButton, null),
        textLabel));
};
export default React.forwardRef((props, ref) => React.createElement(RadioButtonComponent, Object.assign({ innerRef: ref }, props)));
//# sourceMappingURL=RadioButton.js.map